import { aucklandDayKey } from '../services/liveWorkService'

/** Mon=0 … Sun=6 labels for the week strip. */
export const WEEKDAY_LETTERS = ['M', 'T', 'W', 'T', 'F', 'S', 'S'] as const

/**
 * Seven Auckland calendar dates for the week containing `ref` (Monday–Sunday).
 */
export function aucklandWeekDayKeys(ref: Date = new Date()): string[] {
  const todayKey = aucklandDayKey(ref)
  const weekdayName = new Intl.DateTimeFormat('en-US', {
    timeZone: 'Pacific/Auckland',
    weekday: 'short',
  }).format(ref)
  const sunZero: Record<string, number> = {
    Sun: 0,
    Mon: 1,
    Tue: 2,
    Wed: 3,
    Thu: 4,
    Fri: 5,
    Sat: 6,
  }
  const dow = sunZero[weekdayName] ?? 1
  const daysFromMonday = dow === 0 ? 6 : dow - 1

  const [y, m, d] = todayKey.split('-').map(Number)
  const mondayUtc = Date.UTC(y, m - 1, d) - daysFromMonday * 86_400_000

  return Array.from({ length: 7 }, (_, i) => {
    const t = new Date(mondayUtc + i * 86_400_000)
    const yy = t.getUTCFullYear()
    const mm = String(t.getUTCMonth() + 1).padStart(2, '0')
    const dd = String(t.getUTCDate()).padStart(2, '0')
    return `${yy}-${mm}-${dd}`
  })
}

export type HourBoxTone = 'empty' | 'low' | 'ok' | 'high'

/** Colour rules: none → grey; 0–&lt;7 → yellow; 7–9 → green; &gt;9 → red. */
export function hourBoxTone(hours: number): HourBoxTone {
  if (!hours || hours <= 0) return 'empty'
  if (hours > 9) return 'high'
  if (hours >= 7) return 'ok'
  return 'low'
}

export function normalizePersonName(name: string): string {
  return name.trim().toLowerCase().replace(/\s+/g, ' ')
}

export function formatHoursLabel(hours: number): string {
  if (!hours || hours <= 0) return ''
  const rounded = Math.round(hours * 10) / 10
  return Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(1)
}
